export default __webpack_public_path__ + "static/media/subscribe.533b6f2e.svg";